import { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'

import ClientLibrary from './clientPostMessageServ'
import ClientInfoService from './info-service'
import setCssVars from './utils/setCssVars'
import handleInitError from './utils/handleInitError'
import sendInfoLog from './utils/sendInfoLog'
import { setToSDKClientGlobal } from './utils/SDKClientGlobalUtils'

const CommunicatorClient = ({ logger, widgetId, appName, onDataReceive }) => {
  // Initialize client library communication channel
  // Supposed to be used only for embedded widget flow at Client side (no SSR)
  const clientLibraryInstance = useMemo(() => ClientLibrary(widgetId), [widgetId])
  const clientInfoServiceInstance = useMemo(() => ClientInfoService(clientLibraryInstance), [
    clientLibraryInstance
  ])
  const [widgetHelpers, setWidgetHelpers] = useState(null)

  useEffect(() => {
    setToSDKClientGlobal({ clientLibraryInstance })
  }, [clientLibraryInstance])

  useEffect(() => {
    if (widgetHelpers) {
      setCssVars(widgetHelpers, logger)
      handleInitError(widgetHelpers, logger)
      sendInfoLog(widgetHelpers, logger, appName)

      onDataReceive(widgetHelpers)
      setToSDKClientGlobal({ widgetHelpers })
      console.info(
        `[Credible ${appName} widget] \n Received widget helpers from SDK`,
        widgetHelpers
      )
    }
  }, [widgetHelpers])

  useEffect(() => {
    const awaitWidgetHelpers = async () => {
      const widgetHelpers = await clientInfoServiceInstance.widgetHelpersDeferred
      setWidgetHelpers(widgetHelpers)
    }
    awaitWidgetHelpers()
  }, [clientInfoServiceInstance])

  return null
}

CommunicatorClient.propTypes = {
  onDataReceive: PropTypes.func.isRequired,
  widgetId: PropTypes.string.isRequired,
  logger: PropTypes.shape({
    info: PropTypes.func.isRequired,
    error: PropTypes.func.isRequired
  }).isRequired
}

export default CommunicatorClient
